import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Edit,
  DateField,
  Create,
  Filter,
  CardActions,
  ListButton,
  CreateButton,
  CloneButton,
  required,
  SearchInput
} from 'react-admin'

import rowStyle from './rowStyle'

const CreateActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
  </CardActions>
)

const EditActions = ({ basePath, data }) => (
  <CardActions>
    <ListButton basePath={basePath} record={data} />
    <CreateButton basePath={basePath} record={data} />
    <CloneButton basePath={basePath} record={data} />
  </CardActions>
)

const App = {
  filter: (props) => (
    <Filter {...props}>
      <SearchInput label='Search by name' source='name' alwaysOn />
    </Filter>
  ),
  create: (props) => (
    <Create {...props} actions={<CreateActions />}>
      <SimpleForm>
        <TextInput source='name' label='Name' validate={required()} />
        <TextInput source='appStoreProductId' label={`Apple Store's Product ID`} />
      </SimpleForm>
    </Create>
  ),
  edit: (props) => {
    return (
      <Edit actions={<EditActions />} {...props}>
        <SimpleForm>
          <TextField label='id' source='id' />
          <TextInput source='name' label='Name' validate={required()} />
          <TextInput source='appStoreProductId' label={`Apple Store's Product ID`} />
          <DateField source='createdAt' showTime />
          <DateField source='updatedAt' showTime />
        </SimpleForm>
      </Edit>
    )
  },
  list: (props) => (
    <List filters={<App.filter />} title='Apps' {...props}>
      <Datagrid
        rowStyle={rowStyle}
        rowClick='edit'
      >
        <TextField source='name' label='Name' />
        <DateField source='createdAt' />
        <DateField source='updatedAt' />
      </Datagrid>
    </List>
  )
}

export default App
